import { observer } from 'mobx-react'
import React, { FC, useEffect } from 'react'
import styles from './LoginDialog.module.less'
import { Dialog } from 'antd-mobile'
import { commonUtils } from '@/helpers/commonUtils'
import { api } from '@/helpers/api'
import { userService } from '@/services/userService/userService'

export interface LoginDialogProps {
  visible: boolean
  onClose?: () => void
  onLoginSuccess?: () => void
}

let checkTimer: any = null

const LoginDialogContent = observer((props: LoginDialogProps) => {
  const getLoginUrl = async () => {
    const params = userService.getLoginParams()
    userService.postUserActionRecord({
      module: '移动端官网',
      function: '登录弹窗',
      position: '登录按钮',
      action: '点击',
      element: '按钮',
      remark: params,
    })

    const {
      data: { scheme, state },
    } = await api.user.getLoginUrl(params)
    window.location.href = scheme.openlink
    // window.location.href ='weixin://pages/index/index'
    checkLoginStatus(state)
  }

  const checkLoginStatus = async (state: string) => {
    if (!props.visible) {
      return
    }
    const {
      data: { login },
    } = await api.user.confirmH5LoginStatus(state)
    console.log(state, login)

    if (login) {
      await userService.getUserInfo()
      props.onLoginSuccess?.()
      props.onClose?.()
      const { utm, kword } = userService.getLoginParams()
      userService.postUserActionRecord({
        module: '移动端官网',
        function: '登录弹窗',
        position: '登录成功',
        action: '展现',
        element: '页面',
        remark: { utm, kword },
      })
      userService.removeUtmInfo()
    } else {
      checkTimer = setTimeout(() => {
        checkLoginStatus(state)
      }, 1000)
    }
  }

  const stopCheck = () => {
    if (checkTimer) {
      clearTimeout(checkTimer)
      checkTimer = null
    }
  }

  useEffect(() => {
    if (!props.visible) {
      stopCheck()
    }
    return () => {
      stopCheck()
    }
  }, [props.visible])

  return (
    <div className={styles.loginDialogContent}>
      <img
        src={commonUtils.getStaticFile('images/close.png')}
        alt='close'
        className={styles.loginDialogContentClose}
        onClick={() => {
          stopCheck()
          props.onClose?.()
        }}
      />
      <img
        className={styles.logoWithText}
        src={commonUtils.getStaticFile('images/bg_home_banner_title.png')}
        alt='logo-2'
      />
      <div
        className={styles.loginBtn}
        onClick={() => {
          //跳转到登录
          getLoginUrl()
        }}
      >
        <img
          src={commonUtils.getStaticFile('images/icon__wechat-white.png')}
          alt='icon__wechat-white'
        />
        微信一键登录
      </div>
    </div>
  )
})

const LoginDialog: FC<LoginDialogProps> = observer((props: LoginDialogProps) => {
  return (
    <Dialog
      style={
        {
          '--max-width': '100vw',
        } as React.CSSProperties
      }
      visible={props.visible}
      onClose={props.onClose}
      bodyStyle={{
        padding: 0,
        backgroundColor: 'transparent',
        marginTop: '-30%',
      }}
      bodyClassName={styles.loginDialog}
      content={<LoginDialogContent {...props} />}
      getContainer={() => document.body}
    ></Dialog>
  )
})

export default LoginDialog
